export default __webpack_public_path__ + "static/media/meh.815e585b.svg";